import './BalancePoint.css';
import oynamanyaImage from './oynamaya.png';

const GOOGLE_PLAY_URL = 'https://play.google.com/store/apps/details?id=com.atabekhsa.superbalance&hl=tr';
const APP_STORE_URL = 'https://apps.apple.com/us/app/playmania-all-in-one-games/id6760507040';

function GooglePlayIcon() {
  return (
    <svg viewBox="0 0 32 36" aria-hidden="true">
      <path fill="#00d7fe" d="M1.8 1.4 18.9 18 1.9 34.6c-.6-.7-.9-1.7-.9-2.8V4.2c0-1.1.2-2 .8-2.8Z" />
      <path fill="#ffce00" d="m24.5 12.6-5.6 5.4L1.8 1.4c.7-.7 1.8-.7 3-.1l19.7 11.3Z" />
      <path fill="#ff3a44" d="M4.8 34.7c-1 .6-2.2.5-2.9-.1L19 18l5.6 5.5L4.8 34.7Z" />
      <path fill="#00f076" d="m29.2 20.8-4.7 2.7-5.6-5.5 5.6-5.4 4.7 2.7c2.4 1.4 2.4 4.1 0 5.5Z" />
    </svg>
  );
}

function AppleIcon() {
  return (
    <svg viewBox="0 0 32 38" aria-hidden="true">
      <path fill="currentColor" d="M26.8 20.2c0-4.6 3.8-6.8 4-6.9-2.2-3.2-5.6-3.6-6.8-3.6-2.9-.3-5.6 1.7-7.1 1.7-1.5 0-3.8-1.7-6.2-1.6-3.2.1-6.2 1.9-7.9 4.8-3.4 5.8-.9 14.4 2.4 19.2 1.6 2.3 3.5 4.9 6 4.8 2.4-.1 3.3-1.5 6.2-1.5s3.7 1.5 6.2 1.5c2.6 0 4.2-2.3 5.8-4.6 1.8-2.7 2.6-5.3 2.6-5.4-.1 0-5.1-1.9-5.2-8.4ZM22.1 6.7C23.4 5.1 24.3 2.8 24 0c-2 .1-4.4 1.3-5.8 2.9-1.2 1.4-2.3 3.8-2 6.1 2.2.2 4.5-1.1 5.9-2.3Z" />
    </svg>
  );
}

function StoreButton({ href, icon, eyebrow, label, className }) {
  return (
    <a className={`bp-store-button ${className}`} href={href} target="_blank" rel="noreferrer">
      <span className="bp-store-icon">{icon}</span>
      <span className="bp-store-copy"><small>{eyebrow}</small><strong>{label}</strong></span>
      <span className="bp-arrow" aria-hidden="true">↗</span>
    </a>
  );
}

function BalancePoint() {
  return (
    <div className="balance-point">
      <div className="bp-orb bp-orb-one" />
      <div className="bp-orb bp-orb-two" />
      <div className="bp-grid" />

      <main className="bp-content">
        <div className="bp-badge"><span /> TEK UYGULAMA · SINIRSIZ EĞLENCE</div>

        <div className="bp-logo">
          <img src={oynamanyaImage} alt="Oynamanya oyun dünyası" />
          <span className="bp-logo-spark" aria-hidden="true">✦</span>
        </div>

        <p className="bp-kicker">OYUN DÜNYANA HOŞ GELDİN</p>
        <h1>Oyna. Yarış.<br /><em>Eğlenceyi Yakala!</em></h1>
        <p className="bp-description">Birbirinden eğlenceli mini oyunlar, arkadaşlarınla rekabet ve her gün yeni bir macera tek bir yerde.</p>

        <div className="bp-features" aria-label="Oyun özellikleri">
          <span>⚡ Anında Oyna</span><i />
          <span>♟ Onlarca Oyun</span><i />
          <span>♜ Arkadaşlarınla Yarış</span>
        </div>

        <section className="bp-download-card">
          <div className="bp-card-heading">
            <span className="bp-card-icon">↓</span>
            <div><strong>Hemen ücretsiz indir</strong><small>Cihazına uygun mağazayı seç</small></div>
          </div>
          <div className="bp-buttons">
            <StoreButton href={GOOGLE_PLAY_URL} icon={<GooglePlayIcon />} eyebrow="ŞİMDİ İNDİRİN" label="Google Play" className="google" />
            <StoreButton href={APP_STORE_URL} icon={<AppleIcon />} eyebrow="ŞİMDİ İNDİRİN" label="App Store" className="apple" />
          </div>
          <p className="bp-safe">✓ Güvenli indirme <span>•</span> Ücretsiz başla <span>•</span> Tüm yaşlar için</p>
        </section>
      </main>

      <footer className="bp-footer"><strong>OYUNMANYA</strong><span>Her oyun, yeni bir macera.</span></footer>
    </div>
  );
}

export default BalancePoint;
